module.exports = "<div class=\"page-err\">\r\n  <div class=\"err-container text-center\">\r\n    <div class=\"err\">\r\n      <h1>Acesso negado</h1>\r\n      <h2>Você não tem permissão para executar esta ação.</h2>\r\n    </div>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/components/denied/denied.component.html
// module id = ../../../../../src/app/components/denied/denied.component.html
// module chunks = main